import { BooleanFeature } from "./BooleanFeature";
import { FeatureCell } from "./FeatureCell";
import { NumberFeature } from "./NumberFeature";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface PlanFeatureFlagProps {
  title: string;
  feature: string;
  suffix?: string;
}

export const PlanFeatureFlag = ({
  title,
  feature,
  suffix,
}: PlanFeatureFlagProps) => {
  const { plans } = usePlans();

  const renderPlanFeature = (plan: any) => {
    const featureValue = plan.plan_feature_flags[feature];
    const isNumeric = typeof featureValue === "number";

    return (
      <FeatureCell key={plan.id}>
        {isNumeric ? (
          <NumberFeature value={featureValue} suffix={suffix} />
        ) : (
          <BooleanFeature value={!!featureValue} />
        )}
      </FeatureCell>
    );
  };

  return (
    <>
      <FeatureCell>
        <StringFeature className="pr-5" value={title} hideCheckIcon />
      </FeatureCell>
      {plans.map(renderPlanFeature)}
    </>
  );
};
